export enum postFilterTypes {
  ALL = 'all',
  UNREAD = 'unread',
  MARKED = 'marked',
  EMPLOYEES = 'employees',
  STAFFS = 'staffs',
  PARENTS = 'parents',
  STUDENTS = 'students',
  OWN_POST = 'ownPost',
  BOOKMARKED = 'bookmarked',
}
